import React from "react";
import { Route } from "react-router-dom";

import CurationHeader from "curation/containers/CurationHeader";
import MessagePanel from "components/library/MessagePanel";
import CurationDash from "curation/containers/CurationDash";
import NavigationSidebar from "dashboard/containers/NavigationSidebar";
import { CURATION_FILTERS } from "config/constants";

import styles from "./Curation.css";

class Curation extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <NavigationSidebar />

        <div className={styles.content}>
          <CurationHeader />
          <MessagePanel />

          <main className={styles.main}>
            <Route
              exact
              path="/curation"
              render={() => <CurationDash filter={CURATION_FILTERS.DRAFT} />}
            />
            <Route
              exact
              path="/curation/published"
              render={() => (
                <CurationDash filter={CURATION_FILTERS.PUBLISHED} />
              )}
            />
          </main>
        </div>
      </div>
    );
  }
}

export default Curation;
